/**
 * 밑줄 탭(shadcn tabs 의 line 변형) — **머리의 최상위 메뉴**(홈·지원사업·아티클·커뮤니티·마이페이지)에 쓴다.
 * 둘째 층(유형·게시판·프로필 탭)은 검정 알약(pill-tab). 두 층이 같은 모양이면 같은 버튼이 두 줄로 보인다.
 * 켜진 탭: 검정 글자 + 2px 검정 밑줄. 꺼진 탭: 회색 글자, hover 검정. 줄 전체에 얇은 바닥선.
 */
// overflow 를 두지 않는다 — 탭이 바닥선 위로 1px 걸치는데(-mb-px) overflow 가 있으면 그 1px 이 세로 스크롤바가 된다.
export const LINE_TABS_ROW = 'flex w-full items-center gap-4 whitespace-nowrap border-b border-gray-200';
export const LINE_TAB = 'relative -mb-px inline-flex h-8 shrink-0 items-center px-1 text-sm font-medium transition-colors';
export const LINE_TAB_ON = 'text-gray-900';
export const LINE_TAB_OFF = 'text-gray-500 hover:text-gray-900';
/** 켜진 탭 아래의 밑줄. SPA 에서는 framer `layoutId` 로 탭 사이를 미끄러진다. */
export const LINE_TAB_UNDERLINE = 'absolute inset-x-0 bottom-0 h-0.5 bg-gray-900';
